module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1039-7ea1b1a7dcbc624ff3622dc70228f149.png";